import cn from 'classnames';
import Link from 'next/link';
import * as React from 'react';

import { MenuItem, MenuItemType } from '@/types/menu';

import { maybeIsInternalUrl, menuItemRel, toAbsoluteUrl, toRelativeUrl } from './functions/utils';

type Props = {
  item: MenuItem;
  tabIndex?: number;
  ariaHidden?: boolean;
  onClick?: () => void;
  onFocus?: () => void;
  className?: string;
  nameClassName?: string;
};

const MenuItemLink: React.FC<Props> = ({
  item,
  tabIndex,
  ariaHidden,
  onClick,
  onFocus,
  className,
  nameClassName = 'name'
}) => {
  const content = (
    <>
      {item.options.icon && <i className={cn('icon', item.options.icon.prefix, `fa-${item.options.icon.iconName}`)} />}
      <span className={cn(nameClassName)}>{item.name}</span>
    </>
  );

  if (item.type === MenuItemType.INTERNAL || maybeIsInternalUrl(item.resource)) {
    return (
      <Link
        href={toRelativeUrl(item.resource)}
        rel={menuItemRel(item)}
        target={item.options.openNewTab ? '_blank' : undefined}
        tabIndex={tabIndex}
        aria-hidden={ariaHidden}
        onClick={onClick}
        onFocus={onFocus}
        className={className}
      >
        {content}
      </Link>
    );
  }

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={toAbsoluteUrl(item.resource)}
      rel={menuItemRel(item)}
      target={item.options.openNewTab ? '_blank' : undefined}
      tabIndex={tabIndex}
      aria-hidden={ariaHidden}
      onClick={onClick}
      onFocus={onFocus}
      className={className}
    >
      {content}
    </a>
  );
};

export default MenuItemLink;
